module.exports = __webpack_public_path__ + "static/img/introduction.06fa51b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/BSD/About/img/introduction.jpg
// module id = HTer
// module chunks = 171